import request from '@/utils/request'
export function findPointList(data) {
  return request({
    url: '/Location/FindPointList',
    method: 'post',
    data
  })
}
export function queryRoutings(data) {
  return request({
    url: '/Routing/QueryRoutings',
    method: 'post',
    data
  })
}
export function searchGoods(data) {
  return request({
    url: '/Goods/SearchGoods',
    method: 'post',
    data
  })
}
export function bookingRequest(data) {
  return request({
    url: '/Booking/BookingRequest',
    method: 'post',
    data
  })
}
export function getBookingList(data) {
  return request({
    url: '/Booking/GetBookingList',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/station.js